import axios from '@/utils/http';

export default (video_id) => {
  return axios
    .get(`/video/${video_id}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
